import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import './i18n';
import './styles/styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import config from './config';
import { NotificationProvider } from './context/notification.context';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <NotificationProvider>
      <ConfigProvider theme={config.theme}>
        <I18nextProvider i18n={i18next}>
          <App />
        </I18nextProvider>
      </ConfigProvider>
    </NotificationProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
